import { render } from "./NavTabPane.vue?vue&type=template&id=16c5ad9f"
import script from "./NavTabPane.vue?vue&type=script&lang=js"
export * from "./NavTabPane.vue?vue&type=script&lang=js"
script.render = render

export default script